import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

// Fit each complete report section to a landscape page; never crop a card or chart.
export function fitPdfPage(width, height) {
  const scale = Math.min(281 / width, 194 / height);
  return { x: (297 - width * scale) / 2, y: 8, width: width * scale, height: height * scale };
}

export function buildSystemReportPdf(images) {
  if (!images.length) throw new Error('No report pages to export.');
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  images.forEach((image, i) => {
    if (i) doc.addPage();
    const box = fitPdfPage(image.width, image.height);
    doc.addImage(image.data, 'PNG', box.x, box.y, box.width, box.height, undefined, 'FAST');
  });
  return doc;
}

export async function downloadSystemReportPdf(element, month) {
  await document.fonts?.ready;
  // Allow the export copy's Chart.js canvases to settle at their actual card widths.
  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  const images = [];
  for (const section of element.querySelectorAll('[data-pdf-page]')) {
    const canvas = await html2canvas(section, {
      scale: 3, backgroundColor: '#FFFFFF', logging: false,
      windowWidth: 1280, windowHeight: 1000,
    });
    images.push({ data: canvas.toDataURL('image/png'), width: canvas.width, height: canvas.height });
    canvas.width = 0; canvas.height = 0;
  }
  const filename = String(month || 'Report').replace(/[^a-z0-9-_]+/gi, '-');
  buildSystemReportPdf(images).save(`RGA-System-Report-${filename}.pdf`);
}
